<template>
  <q-header>
    <div
      v-if="$q.screen.lt.md"
      class="mb-nav-bar"
    >
      <div class="mb-nav-bar--content left-side">
        <AppNavBarLogo class="row items-center" />
      </div>

      <div class="mb-nav-bar--content middle">
        <AppBarFilterSlotMobile v-if="filtersVisible" />
      </div>

      <div class="mb-nav-bar--content right-side">
        <template
          v-if="!['list-property', 'login'].includes(String(route.name))"
        >
          <GlobalAvatar
            v-if="user"
            size="2rem"
            @click="toggleDrawer"
          />

          <q-btn
            v-else
            class="mb-nav-bar__toggle-btn"
            color="secondary"
            dense
            flat
            icon="menu"
            unelevated
            @click="toggleDrawer"
          />
        </template>

        <AppLanguageSwitcher
          v-if="
            config
            && config.locale.supported.length > 1
            && ['list-property', 'login'].includes(route.name?.toString() || '')
          "
        />
      </div>
    </div>

    <div
      v-else
      class="dp-nav-bar"
    >
      <div class="dp-nav-bar--content left-side">
        <AppNavBarLogo class="row items-center" />
      </div>

      <div class="dp-nav-bar--content middle">
        <template v-if="filtersVisible">
          <SPFilter
            v-for="filter in filtersLocal"
            :key="filter.slug"
            v-model="filterValues[filter.slug]"
            v-bind="filter"
          />
        </template>
      </div>

      <div class="dp-nav-bar--content right-side">
        <AppLanguageSwitcher
          v-if="config && config.locale.supported.length > 1"
          class="dp-nav-bar-item"
          :q-btn-dropdown-props="qBtnDropdownProps"
        />

        <AppListPropertyBtn
          v-if="
            featureConfig.global.listingSubmission
            && !['list-property', 'login'].includes(String(route.name))
          "
          class="dp-nav-bar-item"
        />

        <AppProfileMenu
          class="dp-nav-bar-item"
          :q-btn-dropdown-props="qBtnDropdownProps"
        />
      </div>
    </div>
  </q-header>
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { QBtn, type QBtnDropdownProps, Screen } from 'quasar'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import AppBarFilterSlotMobile from '@/components/AppCommon/AppBarFilterSlotMobile.vue'
import AppLanguageSwitcher from '@/components/AppCommon/AppLanguageSwitcher.vue'
import AppListPropertyBtn from '@/components/AppCommon/AppListPropertyBtn.vue'
import AppNavBarLogo from '@/components/AppCommon/AppNavBarLogo.vue'
import AppProfileMenu from '@/components/AppCommon/AppProfileMenu.vue'
import GlobalAvatar from '@/components/Global/GlobalAvatar.vue'
import SPFilter from '@/components/SearchPage/Filters/SPFilter.vue'
import { useFeatureConfig } from '@/composables/featureConfig'
import { useFilter } from '@/composables/filter/index'
import { useTheme } from '@/composables/theme'
import { useAppStore } from '@/store/modules/app'
import { useAuthStore } from '@/store/modules/auth'
import { useThemeStore } from '@/store/modules/theme'

const route = useRoute()
const themeStore = useThemeStore()
const { config } = storeToRefs(useAppStore())
const { user } = storeToRefs(useAuthStore())
const { featureConfig } = useFeatureConfig()

// const qBtnDropdownProps = configTheme.components.AppNavBar.qBtnDropdownProps as QBtnDropdownProps;
const qBtnDropdownProps = {} as QBtnDropdownProps

const filtersVisible = computed(() => route.name === 'search')

const { breakpoint } = useTheme()

const slot = ref('navbar-top-middle')

const { filtersLocal, filterValues } = useFilter(breakpoint, slot)

const toggleDrawer = () => {
  themeStore.layoutDrawer = !themeStore.layoutDrawer
}

const onResize = useDebounceFn(() => {
  if (Screen.gt.sm) {
    themeStore.layoutDrawer = false
  }

  if (Screen.lt.md) {
    themeStore.layoutOverlay = false
  }
}, 100)

onMounted(() => {
  onResize()

  window.addEventListener('resize', onResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize)
})
</script>
